<template>
  <div class="ext-app-wrapper">
	  <zjy-loading v-if="loading" />
	  <iframe v-show="!loading" :id="code" v-if="urlWithTicket" :src="urlWithTicket" ref="frame" @load="onIframeLoad">
	  </iframe>
  </div>
</template>

<script>
import { getSsoTicket } from '@/api/auth'
import {mapGetters} from "vuex";
import {getNavigationDetail} from "@/api/home";
import ZjyLoading from "@/components/zjy/ZjyLoading.vue";

export default {
  name: "NavigationLayout",
	components: {ZjyLoading},
  props: {
    url: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      require: true
    }
  },
  data(){
    return {
	    loading: false,
	    indicator: <a-icon type="loading" style="font-size: 24px" spin />,
	    urlWithTicket: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo','info']),
  },
  mounted() {
	  this.getNavigationDetail()
  },
  methods: {
	  onIframeLoad() {
		  this.loading = false
	  },
		getNavigationDetail() {
			if (!this.code){
				return
			}
			this.loading = true
			console.log('getNavigationDetail', this.code)
			getNavigationDetail({ code: this.code }).then(res => {
				if (res.success) {
					if(res.data){
						this.appData = res.data
						if (this.url) {
							this.appData.pcUrl = this.url
						}
						if (this.appData.pcUrl) {
							const param = {
								appId: this.appData.id,
								redirectUrl: this.appData.pcUrl
							}
							getSsoTicket(param).then(res => {
								if (res.success) {

									this.urlWithTicket = res.data
								}
							});
						}
					}
				}
			})
		}
  },
	created() {
	}
}
</script>

<style lang="less" scoped>
.ext-app-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
	justify-content: center;
	align-items: center;

	iframe {
		width: 100%;
		height: 100%;
	}
  .app-header-wrapper {
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #E5E6E8;

    .header-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 150px;
      margin-left: 15px;

      .button {
        margin-right: 15px;
        cursor: pointer;
        font-size: 16px;
        color: #2c3e50;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        border-radius: 4px;
        justify-content: center;
        &:hover {
          background: rgb(233,234,235);
        }
      }
    }

    .header-center {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }

    .header-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 150px;
      margin-right: 15px;

      .button {
        margin-left: 15px;
        cursor: pointer;
        font-size: 18px;
        color: #2c3e50;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        &:hover {
          background: rgb(233,234,235);
        }
      }
    }
  }
  iframe {
    flex: 1;
    width: 100%;
    height: 100%;
    border: 0;
    display: block;
  }
}
</style>
